const ENDPOINTS = {
  LOGIN: "/login/",
  LOGOUT: "/logout/",
  REGISTER: "/register/",
  OTP_VERIFY: "/verify-otp/",
  OTP_RESEND:"/resend-otp/",
  RESET_PASSWORD: "/password-reset/",
  RESET_PASSWORD_CONFIRM: "/password-reset-confirm/",

  PROFILE: "/profile/",

  DASHBOARD_DETAILS: "/dashboard/",
  DASHBOARD_DETAILS_FILE: "/get-dashboard-data/",
  UPDATE_FILE: "/upload/",

  GET_MEMBERS: "team/get-members/",
  GET_DRIVERS: "team/get-drivers/",
  ADD_MEMBER: "team/add-member/",

  VEHICLES: "/vehicles/",
  VEHICLE_MODELS: "/vehicle-models/",
  VEHICLE_MAKERS: "/vehicle-makers/",
  FUEL_TYPES: "/fuel-types/",
};

export default ENDPOINTS;